export default __webpack_public_path__ + "static/media/logo.b78a797b.svg";